import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

const tagStyle = css`
  inline-size: fit-content;

  color: #4585ff;
  font-weight: 700;
  font-size: 13px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-transform: uppercase;
`;

export const StyledAnchor = styled.a`
  ${tagStyle}
`;

export const StyledTag = styled.div`
  ${tagStyle}
`;

export const StyledTagEntityLink = styled(EntityLink)`
  ${tagStyle}
`;
